import Vue from 'vue';
import Vuex from 'vuex';

import searchJobResults from './modules/searchJobResults';
import candidatesList from './modules/candidatesList';
import adminStore from './modules/adminStore';
import managerStoreModule from './modules/managerStoreModule';
import recruiterStoreModule from './modules/recruiterStoreModule';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    searchJobResults,
    candidatesList,
    adminStore,
    managerStoreModule,
    recruiterStoreModule,
  },
});
